import { render, staticRenderFns } from "./AccountBlocked.vue?vue&type=template&id=5f57b4b4&"
import script from "./AccountBlocked.vue?vue&type=script&lang=js&"
export * from "./AccountBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports